module.exports = __webpack_public_path__ + "static/img/tit3.7277c95a.png";